import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import 'hammerjs'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

console.log('%cA%cmbin Informatique', 'background:blue;padding:5px;color:white;font-size:33px;font-style:italic;text-align:right', 'font-size:33px')
if (environment.production) {
	enableProdMode()
	window.console.log = function () { }
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.log(err))
